import { render, staticRenderFns } from "./DateTimeCountdown.vue?vue&type=template&id=60b5c8e8&scoped=true"
import script from "./DateTimeCountdown.vue?vue&type=script&lang=js"
export * from "./DateTimeCountdown.vue?vue&type=script&lang=js"
import style0 from "./DateTimeCountdown.vue?vue&type=style&index=0&id=60b5c8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5c8e8",
  null
  
)

export default component.exports